import {KeyModifiers} from 'common/util/keyboard';

export enum Direction {
  Right = `right`,
  Left = `left`,
  Top = `top`,
  Bottom = `bottom`,
}

export interface ExtraResizablePanelAction {
  icon: string;
  value: string;
  label: string;
}

export interface ResizablePanelAttrs {
  'disable-collapsing'?: boolean;
  loading?: boolean;
  'min-adjacent-size'?: number;
  'max-size'?: number;
  'max-auto-size'?: number;
  'min-size'?: number;
  'default-size'?: number;
  'storage-key'?: string;
  'show-collapse-button'?: boolean;
  'extra-actions'?: ExtraResizablePanelAction[];
  'panel-name'?: string;
  'resize-direction'?: Direction;
  'default-ratio'?: number;
  'collapse-key'?: string;
  'collapse-key-modifier'?: KeyModifiers;
  'show-resizing-layout'?: boolean;
  'fixed-size'?: boolean;
}

export interface ResizablePanelState {
  canExpand: boolean;
  hasResized: boolean;
  isCollapsed: boolean;
  isResizing: boolean;
  size: number;
  currentRatio?: number;
  containerWidth: number;
  containerHeight: number;
  snapResetState?: boolean;
}

export type PersistedResizablePanelState = Pick<ResizablePanelState, 'isCollapsed' | 'size' | 'currentRatio'>;

export interface ResizablePanelJsxProps {
  attrs?: ResizablePanelAttrs;
  on?: {
    panelResize?: (ev: CustomEvent<{size: number}>) => void;
  };
  props?: {
    containerEl?: HTMLElement;
  };
}
